import React from 'react';
import freeDeliIcon from '../../assets/free-delivery.png';
import dollar from '../../assets/dollar.png';
import headset from '../../assets/headset.png';
import payments from '../../assets/payments.png';

const IconContentRow = () => {
    const items = [
        { icon: freeDeliIcon, content: 'Free shipping on all orders', heading: 'Free Delivery' },
        { icon: dollar, content: 'Back guarantee under 7 days', heading: 'RETURNS' },
        { icon: headset, content: 'Support online 24 hours a day', heading: 'SUPPORT 24/7' },
        { icon: payments, content: '100% payment security', heading: 'PAYMENT' },
    ];

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 m-12 md:ml-20 mt-2">
            {items.map((item, index) => (
                <div key={index} className="flex items-start">
                    <img src={item.icon} alt={`Icon ${index + 1}`} className="mr-4 w-16 h-16" />
                    <div className="text-left">
                        <h3 className="text-lg font-bold">{item.heading}</h3>
                        <p>{item.content}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default IconContentRow;
